import React from 'react'
import { Button, Image, Grid, GridItem } from '@deal/components'
import ExpertChatButton from '#src/components/ExpertChatButton'
import { ExpertPhoneNumberComponent, DepartmentType } from '#src/generated/graphql'
import { withIdentity, WithIdentityProps } from '#src/containers/Identity'
import PhoneIcon from './icon-phone.svg'
import SquigglyIcon from './icon-squiggly.svg'
import JetExpertImage from './jet-expert.jpg'
import YachtExpertImage from './yacht-expert.jpg'
import styles from './styles.css'

interface ExpertProps {
  departmentType: DepartmentType
  categorySlug: string
  header: JSX.Element
  body: JSX.Element
  cta: string
}

const Expert: React.SFC<ExpertProps & WithIdentityProps> = ({
  departmentType,
  categorySlug,
  header,
  body,
  cta,
  myself
}) => {
  const formatPhoneNumber = (phoneNumber: string) => {
    const cleaned = phoneNumber.toString().replace(/\D/g, '')
    const match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/)
    if (match) {
      const intlCode = match[1] ? '+1 ' : ''
      return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('')
    }
    return null
  }

  return (
    <div className={styles.expert}>
      <Grid>
        <GridItem col={2} mdCol={3}>
          <div className={styles.imageContainer}>
            {departmentType === DepartmentType.YACHT_CHARTERS && (
              <SquigglyIcon className={styles.squigglyIcon} />
            )}
            {departmentType === DepartmentType.JET_CHARTERS ? (
              <Image src={JetExpertImage} className={styles.image} sizes="100vw" />
            ) : (
              <Image src={YachtExpertImage} className={styles.image} sizes="100vw" />
            )}
          </div>
        </GridItem>
        <GridItem col={2} mdCol={5} className={styles.details}>
          <div className={styles.header}>{header}</div>
          <div className={styles.body}>{body}</div>
          <div className={styles.actions}>
            {myself && (
              <ExpertPhoneNumberComponent
                variables={{
                  slug: categorySlug
                }}
              >
                {({ data }) => {
                  if (
                    data &&
                    data.categoryBySlug &&
                    data.categoryBySlug.recommendExpertForConsumer.expert
                  ) {
                    return (
                      <>
                        <ExpertChatButton
                          expertId={data.categoryBySlug.recommendExpertForConsumer.expert.id}
                        >
                          {(startExpertConsumerConversation, loading) => (
                            <Button
                              variant="black"
                              disabled={loading}
                              onClick={() =>
                                startExpertConsumerConversation
                                  ? startExpertConsumerConversation()
                                  : null
                              }
                            >
                              {cta}
                            </Button>
                          )}
                        </ExpertChatButton>

                        {data.categoryBySlug.recommendExpertForConsumer.expert.assignedPhone && (
                          <span className={styles.number}>
                            <PhoneIcon className={styles.phoneIcon} />
                            {formatPhoneNumber(
                              data.categoryBySlug.recommendExpertForConsumer.expert.assignedPhone
                            )}
                          </span>
                        )}
                      </>
                    )
                  } else {
                    return null
                  }
                }}
              </ExpertPhoneNumberComponent>
            )}
          </div>
        </GridItem>
      </Grid>
    </div>
  )
}

export default withIdentity(Expert)
